import { useQuery } from "@tanstack/react-query";

import { getFieldVerificationSummary } from "services";

import { FIELD_VERIFICATION_SUMMARY } from "consts";

interface UseGetFieldVerificationSummaryOptions {
  farmId: string;
  refetchInterval?: number | false;
}

export const useGetFieldVerificationSummary = ({ farmId, refetchInterval = false }: UseGetFieldVerificationSummaryOptions) =>
  useQuery({
    queryKey: [FIELD_VERIFICATION_SUMMARY, farmId],
    queryFn: () => getFieldVerificationSummary({ farmId }),
    enabled: !!farmId,
    refetchInterval,
    staleTime: 15000, // Consider data fresh for 15 seconds
  });
